export const order_by_options = [
    {
        'label': 'High to Low',
        'value': 'desc'
    },
    {
        'label': 'Low to High',
        'value': 'asc',
    }
]